export const PALETTE = {
  bg:        '#0A0A0F',
  primary:   '#FF6B4A',
  secondary: '#E040A0',
  accent:    '#A3FF00',
  blue:      '#4A7CFF',
  white:     '#FFFFFF',
};

const MODEL_COLORS = ['#FF6B4A', '#E040A0', '#A3FF00', '#4A7CFF', '#FFD93D', '#06B6D4'];
export const colorForIndex = (i) => MODEL_COLORS[i % MODEL_COLORS.length];

export const TIMELINE = {
  shatterStart: 0.15,
  shatterEnd:   0.55,
  galaxyStart:  0.45,
  galaxyEnd:    0.95,
};
